import React from "react";

const Header = () => {
  return (
    <section className="header-blue">
      <div className="container">
        <table className="table-borderless w-100">
          <tr>
            <td>
              <p
                style={{
                  fontSize: "2.5rem",
                  fontWeight: "600",
                  color: "white",
                }}
              >
                Regulasi, Panduan PSrE dan Infografik
              </p>
            </td>
            {/* <td>
              <p
                className="d-lg-block d-none mb-0"
                style={{ fontSize: "1rem", color: "white", textSlign: "right" }}
              >
                Materi Ketentuan Peraturan dan Infografik yang Dapat di Download
              </p>
            </td> */}
          </tr>
        </table>
      </div>
    </section>
  );
};

export default Header;
